import React, { Fragment, useState, useEffect } from "react";
import { Typography, Grid, Button, Box, makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { Link, useRouteMatch, useHistory } from "react-router-dom";
// Images
import sentierBackground from "../../../../images/sentierBackground.jpg";
import OBSERVATION from "../../../../images/pictos-ok/OBSERVATION-SUR LE PATRIMOINE-IMMATÉRIEL.svg";
import informations from "../../../../images/pictos-ok/informations reçues sur le patrimoine immatériel.svg";
import Risques from "../../../../images/pictos-ok/Risques pour la protection du patrimoine IMMATÉRIEL.svg";
// Fil d'Ariane
import Breadcrumb from "../../../Breadcrumb";
//theme
import Theme, { useStyles } from "../../../Theme.js";

const Culture = (props) => {
  const classes = useStyles();
  const history = useHistory();
  let { url } = useRouteMatch();
  const [destination, setDestination] = useState();

  useEffect(() => {
    if (props.location.state) {
      setDestination(`${url}/${props.location.state}`);
      console.log(props.location.state);
      document.getElementById(props.location.state).focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * @Description Set le state destination à l'URL qu'il faudra rejoindre
   * @param {*} event
   */
  const handleNav = (event) => {
    setDestination(event.currentTarget.getAttribute("destination"));
    history.push(event.currentTarget.getAttribute("destination"));
  };

  /**
   * @Description Se rend à l'URL indiqué dans le state destination
   */
  const handleGo = () => {
    destination
      ? history.push(destination)
      : // Si pas de destination : affichage d'un message pour le user
        alert(
          "Veuillez indiquer votre réponse avant de passer à l’étape suivante "
        );
  };

  return (
    <Fragment>
      <Breadcrumb size={8} current={2} />
      <Box className={classes.subHeader}>
        <Typography variant="h3" className={classes.subHeaderTitle}>
          Le patrimoine culturel
        </Typography>
        <Typography variant="body1" style={{ fontSize: 12 }}>
          Quel type d’observation avez-vous concernant la culture locale
          rencontrée lors de votre randonnée ?
        </Typography>
      </Box>
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
          <Button
            destination={`${url}/observations`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={OBSERVATION}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Observations sur le patrimoine culturel
          </Button>
        </Grid>
        {/* Deuxième ligne
        Colonne de gauche */}
        <Grid
          item
          xs={6}
          className={classes.column}
          style={{ alignItems: "flex-end" }}
        >
          <Button
            destination={`${url}/informations`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={informations}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Informations reçues sur le patrimoine culturel
          </Button>
          <Box
            className={classes.gridLink}
            style={{ justifyContent: "flex-end", marginBottom: "3vh" }}
          >
            <Button
              onClick={() => history.push("/observation/patrimoine", "culture")}
              className={classes.navButton}
            >
              <ArrowRightAltIcon style={{ transform: "rotate(0.5turn)" }} />
              Etape précédente
            </Button>
          </Box>
        </Grid>
        {/* Deuxième ligne 
        Colonne de droite */}
        <Grid
          item
          xs={6}
          className={classes.column}
          style={{ alignItems: "center" }}
        >
          <Button
            destination={`${url}/risques`}
            className={classes.themeButton}
            onClick={handleNav}
            classes={{ label: "labelButton" }}
          >
            <img
              src={Risques}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Risques pour la protection du patrimoine culturel
          </Button>
          <Box
            className={classes.gridLink}
            style={{ justifyContent: "flex-start", marginBottom: "3vh" }}
          >
            <Button className={classes.navButton} onClick={handleGo}>
              Etape suivante <ArrowRightAltIcon />
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Culture;
